import { Play, ShoppingBag } from "lucide-react";
import { addToBundle } from "./BundleBuilder";
import { RatingBadge } from "./RatingBadge";

export const LaunchRibbon = ({ id }) => (
  <div
    data-testid={`launch-ribbon-${id}`}
    className="absolute top-0 right-0 rounded-bl-xl rounded-tr-2xl bg-gradient-to-r from-amber-400 to-orange-400 text-black text-[10px] font-semibold uppercase tracking-[0.18em] px-3 py-1.5 shadow-lg"
  >
    Launch price · limited time
  </div>
);

export const PriceTag = ({ id, price, was, accent }) => (
  <div className="flex items-baseline gap-2 mb-4" data-testid={`price-${id}`}>
    <span className={`font-display text-2xl ${accent}`}>${price}</span>
    {was && <span className="text-sm text-neutral-500 line-through" data-testid={`price-was-${id}`}>${was}</span>}
  </div>
);

export const ToolkitSongCard = ({ id, t }) => (
  <div
    id={`card-${id}`}
    data-testid={`card-${id}`}
    className={`relative rounded-2xl p-6 md:p-7 pt-10 border transition-colors flex flex-col ${t.card}`}
  >
    {t.was && <LaunchRibbon id={id} />}
    <div className="flex gap-4 mb-4">
      <img
        src={t.cover}
        alt={t.coverAlt}
        className={`w-20 h-20 rounded-md object-cover flex-shrink-0 shadow-lg ${t.coverClass || ""}`}
        data-testid={`cover-${id}`}
      />
      <div className="min-w-0">
        <div className={`text-[10px] uppercase tracking-[0.28em] mb-1 ${t.accent}`}>{t.kicker}</div>
        <h3 className="font-display text-2xl text-neutral-100 leading-tight">{t.song}</h3>
        <p className="text-xs text-neutral-500 mt-1">
          {t.artist} · <em>{t.album}</em>
        </p>
      </div>
    </div>
    <p className="text-sm text-neutral-300 leading-relaxed mb-3">{t.blurb}</p>
    <p className="text-xs text-neutral-400 leading-relaxed mb-5 flex-1">
      <span className={t.accent}>Inside:</span> {t.inside}
    </p>
    <RatingBadge shopId={t.shopId} />
    <PriceTag id={id} price={t.price} was={t.was} accent={t.accent} />
    <div className="flex gap-2">
      <a
        href={t.listen}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`listen-${id}`}
        className={`flex-1 inline-flex items-center justify-center gap-2 rounded-full border text-xs md:text-sm px-4 py-2.5 transition-colors ${t.listenBtn}`}
      >
        <Play size={12} /> Listen
      </a>
      <button
        type="button"
        onClick={() => addToBundle(t.shopId)}
        data-testid={`buy-${id}`}
        className={`flex-1 inline-flex items-center justify-center gap-2 rounded-full text-xs md:text-sm px-4 py-2.5 transition-colors ${t.pdfBtn}`}
      >
        <ShoppingBag size={12} /> Buy
      </button>
    </div>
  </div>
);
